'use client'
import React,{useState} from 'react';
import EmployAside from '../../aside';
import ClientsFournisseursIndex from './clients_fournisseurs';

const ClientsFournisseurs = () => {
  const [isOpenSidebar,setIsOpenSidebar] = useState(false);
  return (

    <div className='main-page-wrapper'>
      <EmployAside isOpenSidebar={isOpenSidebar} setIsOpenSidebar={setIsOpenSidebar}/>

      <ClientsFournisseursIndex setIsOpenSidebar={setIsOpenSidebar}/>
    </div>    
  );
};

export default ClientsFournisseurs;